import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=bb49e03a&scoped=true&"
import script from "./CatalogPage.vue?vue&type=script&lang=ts&"
export * from "./CatalogPage.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=bb49e03a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb49e03a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogFilter: require('/app/components/filter/CatalogFilter/CatalogFilter.vue').default,FilterModal: require('/app/components/filter/FIlterModal/FilterModal.vue').default,CatalogWideBanner: require('/app/components/CatalogWideBanner/CatalogWideBanner.vue').default,Breadcrumb: require('/app/components/Breadcrumb/Breadcrumb.vue').default,InfoBlockLargeEquipment: require('/app/components/InfoBlockLargeEquipment/InfoBlockLargeEquipment.vue').default,ViewportToogle: require('/app/components/ViewportToogle/ViewportToogle.vue').default,FilterButton: require('/app/components/filter/FilterButton/FilterButton.vue').default,SortSelect: require('/app/components/SortSelect/SortSelect.vue').default,SelectFilter: require('/app/components/filter/SelectFilter/SelectFilter.vue').default,TSProductGrid: require('/app/components/ts-components/TSProductGrid/TSProductGrid.vue').default})
